import {
  ApiFailoverAddress,
  FailoverAddress,
  apiFailoverAddressToAddress
} from "../../apiResponse/address";
import { AppType } from "../../apiResponseHelpers";

export interface ApiAppAddress {
  AddressId: string;
  AppId: string;
  AppType: AppType;
  Modified: string;
  Created: string;
  // FailoverAddress?
  Address: ApiFailoverAddress;
}

export interface AppAddress {
  addressId: string;
  appId: string;
  appType: AppType;
  modified: string;
  created: string;
  address: FailoverAddress;
}

export function apiAppAddressToAppAddress(apiAppAddress: ApiAppAddress): AppAddress {
  return {
    addressId: apiAppAddress.AddressId,
    appId: apiAppAddress.AppId,
    appType: apiAppAddress.AppType,
    modified: apiAppAddress.Modified,
    created: apiAppAddress.Created,
    address: apiFailoverAddressToAddress(apiAppAddress.Address)
  };
}
